import type { Theme } from '@voice/shared';

export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute('data-theme', theme);
  const color = theme === 'light' ? '#f4f3ef' : '#0c1015';
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', theme === 'system' ? '#0c1015' : color);
  try {
    localStorage.setItem('voice-theme', theme);
  } catch {
    // Speicher blockiert (z. B. privates Fenster): Einstellung gilt nur für diese Sitzung.
  }
}
